export default "__VITE_ASSET__tQDR8MFr__"